export default {
  title: 'EXCLUSIVE RIDE SETTINGS',
  items: {
    ExclusiveNoShowTimeout: {
      label: 'No Show Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ExclusiveNoShowFee: {
      label: 'No Show Fee',
      type: 'integer',
      unit: '$'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/exclusive-ride-settings.js